import { useCallback } from "react";
import { container } from "tsyringe";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Modal from "components/elements/Modal";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import { useProjectId } from "hooks/useProjectId";
import ForumPostService from "services/projects/ForumPostService";
import { translateISO369 } from "utils/I18nText";
import classes from "./classes.module.scss";

type IProps = {
	post: Pick<ForumPostResponseResource, "id" | "title">;
	isOpen: boolean;
	onClose: () => void;
	onDeleted: (post: Pick<ForumPostResponseResource, "id">) => void;
};

const forumPostService = container.resolve(ForumPostService);

export default function DeletePostModal(props: IProps) {
	const { projectId } = useProjectId();

	const onDeletePost = useCallback(() => {
		forumPostService.delete(projectId, props.post.id).then(() => props.onDeleted(props.post));
	}, [projectId, props]);

	return (
		<Modal isOpen onClose={props.onClose} className={classes["root"]}>
			<div className={classes["header"]}>
				<Typography type="p" size="large" weight="bold">
					{I18n.asset.pages.professional_space.tabs.forum.delete_forum_modal.title}
				</Typography>
				<XMarkIcon className={classes["icon"]} onClick={props.onClose} />
			</div>

			<div className={classes["text-container"]}>
				<Typography type="p">
					{I18n.trslt(I18n.asset.pages.professional_space.tabs.forum.delete_forum_modal.text_1, { name: translateISO369(props.post.title) ?? "undefined" })}
				</Typography>
				<Typography type="p">{I18n.asset.pages.professional_space.tabs.forum.delete_forum_modal.text_2}</Typography>
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onClose}>
					{I18n.asset.pages.professional_space.tabs.forum.delete_forum_modal.cancel}
				</Button>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={onDeletePost}>
					{I18n.asset.pages.professional_space.tabs.forum.delete_forum_modal.confirm}
				</Button>
			</div>
		</Modal>
	);
}
